import Loadable from '../../components/loadable';

const EditEventDefault = Loadable({
  loader: () => import('../../pages/event_defaults/edit_event_default'),
  type: 'drawer',
});

angular.module('gym').value('EditEventDefault', EditEventDefault);
